import React from "react";

export const PageTitleContext = React.createContext<[string, (title: string) => void]>(["Response", () => {}]);

export function usePageTitle() {
	return React.useContext(PageTitleContext);
}